import { render, staticRenderFns } from "./IconSurvey.vue?vue&type=template&id=15f26e85"
import script from "./IconSurvey.vue?vue&type=script&lang=js"
export * from "./IconSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports